export const HAND_FONT = '"Baso Sapi", "Comic Sans MS", "Segoe Print", "Bradley Hand", cursive';

const STYLE_ID = 'baso-sapi-webfont';

export function installHandwritingFont(): void {
  if (typeof document === 'undefined' || document.getElementById(STYLE_ID)) {
    return;
  }
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent =
    "@font-face { font-family: 'Baso Sapi'; src: local('Baso Sapi'), local('BasoSapi'), url('./fonts/BasoSapi.otf') format('opentype'); font-display: swap; }";
  document.head.appendChild(style);
}

export async function warmUpHandwritingFont(): Promise<boolean> {
  if (typeof document === 'undefined' || !('fonts' in document)) {
    return false;
  }
  try {
    await document.fonts.load('32px "Baso Sapi"');
    return document.fonts.check('32px "Baso Sapi"');
  } catch {
    return false;
  }
}
